interface IProps {
  content: any;
}

const CompanyManager = ({ content }: IProps) => {
  return content;
};

export default CompanyManager;
